import { RootState } from '@/store/store';
import { GeneralUser } from '@/types';
import { createSlice } from '@reduxjs/toolkit';

export interface ProfileStep {
  title: string;
  completed: boolean;
  link: string;
}

interface UserSlice {
  user: Partial<GeneralUser>;
  profileCompleteness: ProfileStep[];
  consultantFilters: string;
  franchisorFilters: string;
}

const initialState: UserSlice = {
  user: {},
  profileCompleteness: [],
  consultantFilters: '',
  franchisorFilters: '',
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
    },
    setProfileCompleteness(state, action) {
      state.profileCompleteness = action.payload;
    },
    removeUser(state) {
      state.user = {};
    },
    setConsultantFilters(state, action) {
      state.consultantFilters = action.payload;
    },
    setFranchisorFilters(state, action) {
      state.franchisorFilters = action.payload;
    },
    clearConsultantFilters(state) {
      state.consultantFilters = '';
    },
    clearFranchisorFilters(state) {
      state.franchisorFilters = '';
    },
    // Legacy actions for backward compatibility
    setSelectedFilters(state, action) {
      // Default to consultant filters for backward compatibility
      state.consultantFilters = action.payload;
    },
    clearFilters(state) {
      // Clear both for backward compatibility
      state.consultantFilters = '';
      state.franchisorFilters = '';
    },
  },
});

export const {
  setUser,
  removeUser,
  setProfileCompleteness,
  setConsultantFilters,
  setFranchisorFilters,
  clearConsultantFilters,
  clearFranchisorFilters,
  setSelectedFilters,
  clearFilters,
} = userSlice.actions;

export const selectUser = (state: RootState) => state.user.user;
export const selectProfileCompleteness = (state: RootState) =>
  state.user.profileCompleteness;
export const selectConsultantFilters = (state: RootState) =>
  state.user.consultantFilters;
export const selectFranchisorFilters = (state: RootState) =>
  state.user.franchisorFilters;
// Legacy selector for backward compatibility
export const selectFilters = (state: RootState) => state.user.consultantFilters;

export default userSlice.reducer;
